import { createSelector } from 'reselect';
import { searchDropdownBuyItAgainSelector } from 'selectors/testTarget/offers/searchDropdownBuyItAgain/searchDropdownBuyItAgainSelector';

const showSelector = createSelector(searchDropdownBuyItAgainSelector, searchDropdownBuyItAgain => !!searchDropdownBuyItAgain.show);

export { showSelector };
